import {FormControl, InlineLink, Text} from '@primer/react-brand'
import type {GeneralConsentLanguageProps} from './types'
import {getAnalyticsEvent} from '../../../../../../lib/utils/analytics'
import {t} from '../../../../../../lib/utils/localization'

export default function Canada({
  fieldName,
  hasPhone = false,
  privacyStatementHref,
  emailSubscriptionSettingsLinkHref,
  children,
}: GeneralConsentLanguageProps) {
  return (
    <FormControl>
      <FormControl.Label htmlFor={fieldName} data-testid="label">
        <Text weight="semibold">
          {t(
            hasPhone
              ? 'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the'
              : 'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the',
          )}{' '}
          <InlineLink
            {...getAnalyticsEvent({
              action: t('Promotional Communications Manager'),
              tag: 'hyperlink',
              context: 'consent_language_canada',
              location: 'form',
            })}
            href={emailSubscriptionSettingsLinkHref}
          >
            {t('Promotional Communications Manager')}
          </InlineLink>
          .{' '}
          <InlineLink
            {...getAnalyticsEvent({
              action: t('GitHub Privacy Statement'),
              tag: 'hyperlink',
              context: 'consent_language_canada',
              location: 'form',
            })}
            href={privacyStatementHref}
          >
            {t('GitHub Privacy Statement')}
          </InlineLink>
          .
        </Text>
      </FormControl.Label>

      {children}
    </FormControl>
  )
}
